import { makeStyles } from '@material-ui/core/styles';

export const useSummaryStyles = makeStyles(theme => ({
  marginBotton: {
    marginBottom: `${theme.spacing(3)}px !important`
  }
}));
